import { render, staticRenderFns } from "./FolderSelector.vue?vue&type=template&id=ce4e00dc&"
import script from "./FolderSelector.vue?vue&type=script&lang=js&"
export * from "./FolderSelector.vue?vue&type=script&lang=js&"
import style0 from "./FolderSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports